export const isDevelopment = import.meta.env.MODE === 'development';
// Toggles OnePortal related UI changes. Enabled for local dev and integ, disabled for lab/staging/prod.
export const FEATURE_ONEPORTAL = import.meta.env.VITE_FEATURE_ONEPORTAL === 'true';
export const APP_VERSION = __APP_VERSION__;
export const PROBONIO_IMPRINT = 'https://www.probonio.de/impressum';
export const PROBONIO_FAQ = 'https://probonio.de/faq';
export const BIKELEASING_FAQ = 'https://bikeleasing.de/faq';
export const BIKELEASING_FAQ_EN = 'https://bikeleasing.de/en/faq';
export const BIKELEASING_HOW_TO_DIENSTRAD = 'https://www.youtube.com/watch?v=PLy7WGVNcFg';
export const BIKELEASING_LEASABLE_ACCESSORIES_DE = 'https://pim.bikeleasing.de/get-asset/PDF/DE/Zubeh%C3%B6r-Leasing.pdf';
export const BIKELEASING_LEASABLE_ACCESSORIES_EN =
  'https://pim.bikeleasing.de/get-asset/PDF/EN/Germany/Zubeh%C3%B6r-Leasing_ENGLISCH_2022.pdf';
export const BIKELEASING_PIM_URL = import.meta.env.VITE_BIKELEASING_PIM_URL;
